module.exports = __webpack_public_path__ + "static/media/README.c208c59a.md";